module.exports = __webpack_public_path__ + "img/businessGuide.fec348cd.svg";